module.exports = __webpack_public_path__ + "images/feature/inbox-img2-a76d492afa92ba55223098ed278cb9c9.png";